import { render, staticRenderFns } from "./store-classify.vue?vue&type=template&id=255afa45&scoped=true"
import script from "./store-classify.vue?vue&type=script&lang=js"
export * from "./store-classify.vue?vue&type=script&lang=js"
import style0 from "./store-classify.vue?vue&type=style&index=0&id=255afa45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255afa45",
  null
  
)

export default component.exports